import React, { Component } from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import { Input, Select, DatePicker, Icon, Layout, Button, message } from "antd";
import "antd/dist/antd.css";
import "./style.scss";
import ClickShare from "../../../../../common/components/ClickShare/ClickShare"
import moment from "moment";

const { Option } = Select;
const { RangePicker } = DatePicker;
const { Header } = Layout;

export class HeaderBar extends Component {

  static propTypes = {
    filterConditions: PropTypes.object,
    updateFilterConditions: PropTypes.func,
    fetchTasks: PropTypes.func,
    type: PropTypes.string
  };

  static defaultProps = {
    filterConditions: {
      queryValue: "",
      deviceId: "",
      platform: 0,
      beginTime: moment().startOf("week"),
      endTime: moment().startOf("day")
    },
    updateFilterConditions: null,
    fetchTasks: null
  };

  render() {
    const { filterConditions, type } = this.props;
    return (
      <Header className="header">
        <div className="tasklist-filterbar-container">
          <Input.Group compact className="filterbar-group">
            {
              type === "native" &&
              <Select
                data-test="platform-selector"
                value={filterConditions.platform}
                onChange={this.handlePlatformChange}
                style={{ minWidth: "100px" }}
              >
                <Option value={0}>全部平台</Option>
                <Option value={1}>Android</Option>
                <Option value={2}>iOS</Option>
              </Select>
            }
            <RangePicker
              data-test="range-picker"
              allowClear={false}
              format="YYYY-MM-DD"
              placeholder={["起始时间", "结束时间"]}
              onChange={this.handleTimeRangeChange}
              value={[moment(filterConditions.beginTime), moment(filterConditions.endTime)]}
              style={{ minWidth: "240px" }}
            />
            <Input
              data-test="query-input"
              className="filter-input"
              placeholder={type === "native" ? "设备 ID 或用户 UID" : "设备编号"}
              value={type === "native" ? filterConditions.queryValue : filterConditions.deviceId}
              onChange={this.handleQueryValueChange}
              suffix={
                (type === "native" ? filterConditions.queryValue : filterConditions.deviceId) ? (
                  <Icon
                    data-test="clean-query-icon"
                    className="empty-search"
                    key="empty-search"
                    type="close-circle"
                    onClick={this.handleCleanQueryValue}
                  />
                ) : (
                  <span />
                )
              }
            />
          </Input.Group>
          <Button data-test="search-button" icon="search" type="primary" onClick={this.handleSearch}>
            搜索
          </Button>
        </div>
        <ClickShare buttonId={"share-button"} shareUrl={this.composeShareUrl()} buttonText={"分享"} />
      </Header>
    );
  }

  composeShareUrl = () => {
    const {filterConditions, type, pathname} = this.props;
    if (type === "native") {
      const queryValue = encodeURIComponent(String(filterConditions.queryValue || "").trim());
      return `${window.location.origin}/#${pathname}?identifier=${queryValue}&beginTime=${moment(filterConditions.beginTime).valueOf()}&endTime=${moment(filterConditions.endTime).valueOf()}&platform=${filterConditions.platform}`
    } else {
      return `${window.location.origin}/#${pathname}?deviceId=${filterConditions.deviceId}&beginTime=${moment(filterConditions.beginTime).valueOf()}&endTime=${moment(filterConditions.endTime).valueOf()}`
    }
  };

  // event handlers
  handleSearch = () => {
    const { filterConditions, fetchTasks, type } = this.props;
    const queryValue = type === "native" ? String(filterConditions.queryValue || "").trim() : filterConditions.deviceId;
    if (!queryValue) {
      message.error(type === "native" ? "必须填写 UID 或设备 ID 才能查询" : "必须填写设备编号才能查询");
      return;
    }
    if (type === "native") {
      fetchTasks({
        queryValue,
        platform: filterConditions.platform,
        beginTime: moment(filterConditions.beginTime).valueOf(),
        endTime: moment(filterConditions.endTime).valueOf()
      });
    } else {
      fetchTasks({
        deviceId: filterConditions.deviceId,
        beginTime: moment(filterConditions.beginTime).valueOf(),
        endTime: moment(filterConditions.endTime).valueOf()
      })
    }

  };

  handleQueryValueChange = e => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      ...(this.props.type === "native"
        ? { queryValue: e.target.value }
        : { deviceId: e.target.value })
    });
  };

  handleCleanQueryValue = () => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      ...(this.props.type === "native" ? { queryValue: "" } : { deviceId: "" })
    });
  };

  handlePlatformChange = value => {
    const { filterConditions, updateFilterConditions } = this.props;

    updateFilterConditions({
      ...filterConditions,
      platform: value
    });
  };

  handleTimeRangeChange = value => {
    const { filterConditions, updateFilterConditions } = this.props;
    const [beginMoment, endMoment] = value;

    if (endMoment.diff(beginMoment) >= 7 * 86400000) {
      message.warn("请保证选择的时间范围不超过7天");
      return;
    }
    updateFilterConditions({
      ...filterConditions,
      beginTime: beginMoment.valueOf(),
      endTime: endMoment.valueOf()
    });

  };
}

function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
    search: state.router.location.search,
    hash: state.router.location.hash,
  }
}

export default connect(mapStateToProps)(HeaderBar);
